import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, doc, getDoc, getDocs, setDoc, deleteDoc, query, where, updateDoc } from 'firebase/firestore';
import { firestore } from './../../FirebaseUtils';
import QuestionCard from './QuestionCard';
import { Alert, Button, Table } from 'react-bootstrap';

function AdminUser() {
    const employeeIdRef = useRef();
    const emailRef = useRef();

    const [ loading, setLoading ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState();

    const [ employeeId, setEmployeeId ] = useState();
    const [ userDetails, setUserDetails ] = useState();

    async function onClickSearchByEmployeeId(e) {
        const employeeId = employeeIdRef.current.value.trim();

        if (!employeeId) {
            setErrorMessage("กรุณาระบุรหัสพนักงาน");
            return;
        }

        setErrorMessage(null);

        getDetailsByEmployeeId(employeeId);
    }

    function onClickSearchByEmail(e) {
        const email = emailRef.current.value.trim();
        if (!email) {
            setErrorMessage("กรุณาระบุอีเมล์");
            return;
        }

        setErrorMessage(null);

        getDetailsByEmail(email);
    }

    async function getDetailsByEmployeeId(employeeId) {
        setLoading(true);

        let email = null;

        try {
            const docRef = doc(firestore, 'employees', employeeId);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {
                email = docSnap.data().email;
            }
            else {
                console.log('No such document!');

                setUserDetails(null);

                setErrorMessage('ไม่พบข้อมูล');
                setLoading(false);
                return;
            }
        }
        catch (error) {
            console.error("Error getting documents:", error);

            setUserDetails(null);

            setErrorMessage(error);
            setLoading(false);
            return;
        }

        await getDetailsByEmail(email);

        setLoading(false);
    }

    async function getDetailsByEmail(email) {
        setLoading(true);

        try {
            const docRef = doc(firestore, 'users', email);
            const docSnap = await getDoc(docRef);

            if (docSnap.exists()) {

                const employeeId = await getEmployeeIdByEmail(email);

                setEmployeeId(employeeId);

                setUserDetails(docSnap.data());
            }
            else {
                console.log('No such document!');

                setUserDetails(null);

                setErrorMessage('ไม่พบข้อมูล');
                setLoading(false);
                return;
            }
        }
        catch (error) {
            console.error("Error getting documents:", error);

            setUserDetails(null);

            setErrorMessage(error);
            setLoading(false);
            return;
        }

        setLoading(false);
    }

    async function getEmployeeIdByEmail(email) {
        try {
            const q = query(collection(firestore, 'employees'), where('email', '==', email));
            const querySnapshot = await getDocs(q);
            if (querySnapshot.docs.length > 0) {
                console.log('Found ', email, ' in doc: ', querySnapshot.docs[0].id);

                return querySnapshot.docs[0].id;
            } 
            else {
                return null;
            }
        }
        catch (error) {
            console.log('query fails ', error);

            return null;
        }
    }

    async function banUser(e) {
        const email = userDetails.email;

        if (!window.confirm(`คุณต้องการระงับการใช้งานใช่หรือไม่`)) {
            return;
        }

        setLoading(true);

        const userRef = doc(firestore, 'users', email);
        try {
            await updateDoc(userRef, {
                isBanned: true,
            });
            console.log('User banned status updated successfully!');
        }
        catch (error) {
            console.error('Error updating user banned status: ', error);
        }

        getDetailsByEmail(email);

        setLoading(false);
    }

    async function unbanUser(e) {
        const email = userDetails.email;
        
        if (!window.confirm(`คุณต้องการยกเลิกการระงับการใช้งานใช่หรือไม่`)) {
            return;
        }

        setLoading(true);

        const userRef = doc(firestore, 'users', email);
        try {
            await updateDoc(userRef, {
                isBanned: false,
            });
            console.log('User banned status updated successfully!');
        }
        catch (error) {
            console.error('Error updating user banned status: ', error);
        }

        getDetailsByEmail(email);

        setLoading(false);
    }

    const captionStyle = { backgroundColor: '#eee' };

    return (
        <div>
            <Table>
                <tbody>
                    <tr>
                        <td>ค้นหาด้วยรหัสพนักงาน</td>
                        <td><input type="text" ref={employeeIdRef} /></td>
                        <td><Button disabled={loading} onClick={onClickSearchByEmployeeId}>ค้นหา</Button></td>
                    </tr>
                    <tr>
                        <td>ค้นหาด้วยอีเมล์</td>
                        <td><input type="text" ref={emailRef} /></td>
                        <td><Button disabled={loading} onClick={onClickSearchByEmail}>ค้นหา</Button></td>
                    </tr>
                </tbody>
            </Table>
            { errorMessage ? <Alert variant='danger'>{errorMessage}</Alert> : null }
            {
                userDetails ?
                    <div className='mt-3' style={{ padding: '0px 0px 0px 0px' }}>
                        <Table style={{ border: '0px', padding: '0px 0px 0px 0px', border: '1px solid #eee' }}>
                            <tbody>
                                <tr>
                                    <td style={captionStyle}>รหัสพนักงาน</td>
                                    <td>{employeeId}</td>
                                </tr>
                                <tr>
                                    <td style={captionStyle}>อีเมล์</td>
                                    <td>{userDetails.email}</td>
                                </tr>
                                <tr>
                                    <td style={captionStyle}>ชื่อ</td>
                                    <td>{userDetails.name}</td>
                                </tr>
                                <tr>
                                    <td style={captionStyle}>นามสกุล</td>
                                    <td>{userDetails.surname}</td>
                                </tr>
                                <tr>
                                    <td style={captionStyle}>การระงับใช้งาน</td>
                                    <td>{userDetails.isBanned ? <span style={{color:'red'}}>ถูกระงับการใช้งาน</span> : "ใช้งานได้ปกติ"}</td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                    {
                                        userDetails.isBanned ?
                                            <Button disabled={loading} variant='warning' onClick={unbanUser}>ยกเลิกการระงับใช้งาน</Button>
                                        :
                                            <Button disabled={loading} variant='danger' onClick={banUser}>ระงับการใช้งาน</Button>
                                    }
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                :
                    null
            }
            
        </div>
    );
}

export default AdminUser;
